import { render, staticRenderFns } from "./ImgFallback.vue?vue&type=template&id=a9ba6462&"
import script from "./ImgFallback.vue?vue&type=script&lang=js&"
export * from "./ImgFallback.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../var/task/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/task/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('a9ba6462')) {
      api.createRecord('a9ba6462', component.options)
    } else {
      api.reload('a9ba6462', component.options)
    }
    module.hot.accept("./ImgFallback.vue?vue&type=template&id=a9ba6462&", function () {
      api.rerender('a9ba6462', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "tmp/tmp-203ngpnSk8sy9/JS/comp/ImgFallback.vue"
export default component.exports